<template>
  <td class="text-xs-right">
    <v-chip :class="chipClass()" small text-color="white">
      {{ $t(`status.${value}`) }}
    </v-chip>
  </td>
</template>

<script>
export default {
  props: [ 'value' ],
  methods: {
    chipClass() {
      return `invoice ${this.value}`;
    }
  }
}
</script>

<style>
  .v-chip.payment.all         { background-color: #757575 !important; }
  .v-chip.payment.waiting     { background-color: #546E7A !important; }
  .v-chip.payment.processing  { background-color: #546E7A !important; }
  .v-chip.payment.approved    { background-color: #33691E !important; }
  .v-chip.payment.cancelled   { background-color: #B71C1C !important; }
  .v-chip.payment.completed   { background-color: #1B5E20 !important; }
  .v-chip.payment.failed      { background-color: #E53935 !important; }
  .v-chip.payment.refunded    { background-color: #EF6C00 !important; }
  .v-chip.payment.anticipated { background-color: #006064 !important; }
</style>
